/**
 * ConfirmPasswordForm.jsx
 * Created by michaelbray on 2/13/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import PasswordStrengthIndicator from '../../../../components/sharedComponents/PasswordStrengthIndicator';
import Button from '../../../sharedComponents/Button';
import TextField from '../../../sharedComponents/TextField';
import { FlexCol, FlexRow } from '../../../sharedComponents/FlexGrid';
import Heading from '../../../sharedComponents/Heading';
import Alert from '../../../../components/sharedComponents/Alert';

const propTypes = {
    label: PropTypes.string,
    errorText: PropTypes.string,
    confirmPasswords: PropTypes.func
};

export default class ConfirmPasswordForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            password1: '',
            password2: '',
            disabled: false
        };

        this.password1TextChange = this.password1TextChange.bind(this);
        this.password2TextChange = this.password2TextChange.bind(this);
        this.setPassword1Ref = this.setPassword1Ref.bind(this);
        this.setPassword2Ref = this.setPassword2Ref.bind(this);
        this.submitForm = this.submitForm.bind(this);
    }

    componentDidMount() {
        this.password1.focus();
    }

    setPassword1Ref(element) {
        this.password1 = element;
    }

    setPassword2Ref(element) {
        this.password2 = element;
    }

    password1TextChange(e) {
        this.setState({
            password1: e.target.value
        });
    }

    password2TextChange(e) {
        this.setState({
            password2: e.target.value
        });
    }
  

    submitForm(e) {
        e.preventDefault();
        this.setState({
            disabled: true
        }, this.props.confirmPasswords({
            password1: this.state.password1,
            password2: this.state.password2
        }));
    }

    render() {
        let error = null;
        let disabled = this.state.disabled;

        if (this.props.errorText) {
            disabled = false;
            error = (
                <Alert
                    type="error"
                    className="mb-2">
                    {this.props.errorText}
                </Alert>
            );
        }

        return (
            <FlexRow justifyContent="center">
                <FlexCol sm={8} className="rec-acct-modal-log-in-confirmation-body">
                    <Heading
                        headingLevel={1}
                        appearance="display"
                        className="rec-acct-modal-title"
                        id="confirmPasswordModalHeading">
                        {this.props.label}
                    </Heading>
                    {error}
                    <form onSubmit={this.submitForm}>
                        <div className="form-item-wrap">
                            <TextField
                                type="password"
                                label="New Password"
                                innerRef={this.setPassword1Ref}
                                onChange={(event) => this.password1TextChange(event)}
                                className="rec-acct-password"
                                id="rec-acct-password"
                                autoComplete="off"
                                enableShowPassword />
                        </div>
                        <div className="form-item-wrap">
                            <TextField
                                type="password"
                                label="Re-Enter Password"
                                innerRef={this.setPassword2Ref}
                                onChange={(event) => this.password2TextChange(event)}
                                className="rec-acct-password"
                                id="rec-acct-password-confirm"
                                autoComplete="off"
                                enableShowPassword />
                        </div>

                        <PasswordStrengthIndicator password={this.state.password1} />

                        <Button
                            shouldFitContainer
                            size="lg"
                            type="submit"
                            className="rec-acct-sign-in-btn"
                            title={this.props.label}
                            isDisabled={disabled}
                            aria-label={this.props.label}>
                            {this.props.label}
                        </Button>
                    </form>
                </FlexCol>
            </FlexRow>
        );
    }
}

ConfirmPasswordForm.propTypes = propTypes;
